<script>
import router from "../../router";
import Alert from "@/components/Alert";
export default {
  name: "ViewPurchaseOrder",
  components: {
    Alert
  },
  data() {
    return {
      decimal_separator: ".",
precision: 0,
      currency: "",
      order: {
        items: []
      }
    };
  },
  methods: {
    details(id) {
      this.$api
        .getAPI({
          _action: "/stock_adjustment/detail/" + id
        })
        .then(res => {
          this.order = res;
          this.order.items = res.items;
        });
    },
    gettoback() {
      router.push("/stock-adjustment");
    }
  },
  mounted() {
    this.decimal_separator = localStorage.getItem("decimal_separator") || ".";
this.precision = (localStorage.getItem("decimal_separator") || "") == "" ? 0 : 2;
    if (localStorage.getItem("currency")) {
      this.currency = localStorage.getItem("currency");
    }

    if (this.$route.params.id) {
      this.details(this.$route.params.id);
    }
  }
};
</script>
<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-9">
            <div class="card rounded-5 border">
              <div class="card-header bg-white border-bottom px-lg-5 px-4 py-4">
                <div class="row">
                  <div class="col-lg-4 col-md-5 align-self-center mb-md-0 mb-3">
                    <a href="javascript:void(0)" @click="gettoback()" class="text-primary">
                      <i class="mdi mdi-chevron-left"></i>
                      {{$lang.messages.all_stock_adjustments}}
                    </a>
                  </div>
                </div>
              </div>
              <div class="card-body form-style px-lg-5 px-4 py-4">
                <div class="row mb-4">
                  <div class="col-lg-9">
                    <h1 class="mb-0">{{order.so_number}}</h1>
                  </div>
                </div>
                <div class="row mb-5">
                  <div class="col-lg-12">
                    <table>
                      <tr>
                        <td class="pr-3 f-semi-bold">{{$lang.messages.date}}:</td>
                        <td>{{order.created_at | moment("MMM DD, YYYY") }}</td>
                      </tr>
                      <tr>
                        <td class="pr-3 f-semi-bold">{{$lang.messages.reason}}:</td>
                        <td v-if="order.reason == 'RECEIVE_ITEMS'">{{$lang.messages.received_item}}</td>
                        <td
                          v-else-if="order.reason == 'INVENTORY_COUNT'"
                        >{{$lang.messages.inventory_count}}</td>
                        <td v-else-if="order.reason == 'LOSS'">{{$lang.messages.loss}}</td>
                        <td v-else-if="order.reason == 'DAMAGE'">{{$lang.messages.damage}}</td>
                      </tr>
                      <tr>
                        <td class="f-semi-bold pr-3">{{$lang.messages.adjust_by}}:</td>
                        <td>{{order.adjustedBy}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-lg-6">
                    <h4 class="mb-3 f-semi-bold">{{$lang.messages.store}}</h4>
                    <p>{{order.store_name}}</p>
                  </div>
                  <div class="col-12 mt-4" v-if="order.note">
                    <p class="f-semi-bold mb-0">{{$lang.messages.notes}}:</p>
                    <p>{{order.notes}}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <h3>{{$lang.messages.items}}</h3>
                    <table class="table table-striped table-style-1 table-responsive">
                      <thead>
                        <tr>
                          <th scope="col">{{$lang.messages.item}}</th>
                          <th
                            scope="col"
                            class="text-right"
                            v-if="order.reason == 'RECEIVE_ITEMS'"
                          >{{$lang.messages.add_stock}}</th>
                          <th
                            scope="col"
                            class="text-right"
                            v-if="order.reason == 'RECEIVE_ITEMS'"
                          >{{$lang.messages.cost}}</th>
                          <th
                            scope="col"
                            class="text-right"
                            v-if="order.reason == 'INVENTORY_COUNT'"
                          >{{$lang.messages.counted_stock}}</th>
                          <th
                            scope="col"
                            class="text-right"
                            v-if="order.reason == 'LOSS' || order.reason == 'DAMAGE'"
                          >{{$lang.messages.remove_stock}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="obj in order.items" :key="obj.id">
                          <td>
                            {{obj.item.name}}
                            <br />
                            <span
                              class="font-14 text-grey"
                              v-if="obj.item.sku"
                            >{{$lang.messages.sku}} {{obj.item.sku}}</span>
                          </td>
                          <td
                            class="text-right"
                            v-if="order.reason == 'RECEIVE_ITEMS'"
                          >{{obj.add_stock}}</td>
                          <td class="text-right" v-if="order.reason == 'RECEIVE_ITEMS'">
                            <vue-numeric
                              v-bind:precision="precision"
                              :separator="decimal_separator"
                              :value="Math.abs(obj.cost)"
                              :currency="currency"
                              :read-only="true"
                            />
                          </td>
                          <td
                            class="text-right"
                            v-if="order.reason == 'INVENTORY_COUNT'"
                          >{{obj.counted_stock}}</td>
                          <td
                            class="text-right"
                            v-if="order.reason == 'LOSS' || order.reason == 'DAMAGE'"
                          >{{obj.remove_stock}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>